<template>
  <div class="t-feedback js-form" :class="{ _error: infoForm.error }">
    <div class="t-container">
      <transition name="fadeRight">
        <success-cmp
          v-if="infoForm.success"
          class="_white"
          :props="{
            title: successTitle,
            text: successText,
            // btnEvent: $root.staticText.modal.successBtnEvent,
            // btnCalendar: $root.staticText.modal.successBtnCalendar,
          }"
        ></success-cmp>
      </transition>
      <transition name="fadeRight">
        <error-cmp
          v-if="infoForm.error"
          class="_white"
          :props="{
            title: errorTitle,
            text: errorTextForm ? errorTextForm : errorText,
          }"
        >
        </error-cmp>
      </transition>
      <transition name="fadeRight">
        <div v-show="!infoForm.success && !infoForm.error" class="t-feedback__container">
          <div class="t-feedback__top">
            <h2 class="t-feedback__title" v-html="formInfo.title"></h2>
            <a v-if="btnLink" :href="btnLink" target="_blank" class="t-feedback__btn-left t-btn _border _big">
              {{ btnLeft }}
            </a>
            <div v-if="formInfo.description" class="t-feedback__text">{{ formInfo.description }}</div>
          </div>
          <div class="t-feedback__bottom">
            <form-dynamic-cmp
              ref="dynamicForm"
              class="_white"
              :class-white="true"
              :form-info="formInfo"
              :button="button"
              :check="check"
              :action="action"
            >
            </form-dynamic-cmp>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import success from "@components/base/modals/success"
import error from "@components/base/modals/error"
import formDynamic from "@components/base/form-dynamic.vue"

export default {
  data() {
    return {
      errorTextForm: null,
      infoForm: {
        success: false,
        error: false,
      },
    }
  },
  props: {
    formInfo: {
      type: Object,
    },
    button: {
      type: String,
    },
    btnLeft: {
      type: String,
    },
    btnLink: {
      type: String,
    },
    check: {
      type: Boolean,
      default: false,
    },
    successTitle: {
      type: String,
      default: window.staticText.modal.successTitle,
    },
    successText: {
      type: String,
      default: window.staticText.modal.successText2,
    },
    errorTitle: {
      type: String,
      default: window.staticText.modal.errorTitle,
    },
    errorText: {
      type: String,
      default: window.staticText.modal.errorText,
    },
    action: {
      type: String,
      default: "feedback/send",
    },
    freezeForm: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "success-cmp": success,
    "error-cmp": error,
    "form-dynamic-cmp": formDynamic,
  },
  computed: {
    ...mapGetters("modal", ["modalState"]),
  },
  methods: {
    formClear() {
      this.$refs.dynamicForm.clearFrom()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/templates/components/base/form-green.vue